module.exports = __webpack_public_path__ + "5ade2a1f6cc9f80b5ea03efef053f772.png";